import { render, staticRenderFns } from "./RoleUsers.vue?vue&type=template&id=7ed469b5&"
import script from "./RoleUsers.vue?vue&type=script&lang=ts&"
export * from "./RoleUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports